import { trigger, transition, style, animate, state } from '@angular/animations';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pop-overs-title',
  templateUrl: './pop-overs-title.component.html',
  styleUrls: ['./pop-overs-title.component.scss'],
  animations: [
    trigger('fade', [
      transition(':enter', [
        style({opacity: '0'}),
        animate('150ms', style({opacity: '1'}),),
      ]),
      transition(':leave', [
          animate('150ms', style({opacity: '0'}),),
      ]),
    ])     
  ]
})
export class PopOversTitleComponent {

  // OutPuts
  @Output() Show = new EventEmitter<boolean>()
  @Output() Hide = new EventEmitter<boolean>()

  //
  @Input('title') public Title: string = 'PopOvers Title';
  @Input('content') public Content: string = 'Body Content';

  // props
  protected status: boolean = false

  constructor() {}

  protected togglePopOvers(status?: boolean) {
    if (status == true) this.showPopOvers()
    else if (status == false) this.hidePopOvers()
    else {
      if (this.status) this.hidePopOvers()
      else this.showPopOvers()
    }
  }

  private showPopOvers() {

    //
    this.status = true
    //
    this.Show.emit(true)

  }

  private hidePopOvers() {

    //
    this.status = false
    //    
    this.Hide.emit(true)

  }

}
